import * as React from 'react';
import Button from '@mui/material/Button';
import cn from 'classnames';

import { IconButtonProps } from '../../types';
import { useTheme } from '../../../../theme';
import { Choosed } from '../../../../Icons';
import Loader from '../Loader/Loader';

const IconButton: React.FC<IconButtonProps> = ({
	classes,
	children,
	isSuccess,
	isLoading,
	disabled,
	disableElevation = true,
	...restProps
}) => {
	const { IconButton: theme } = useTheme('BaseComponents');

	return (
		<Button
			variant="contained"
			classes={{
				...classes,
				root: cn(theme.root, classes?.root, {
					[theme.success]: isSuccess,
					[theme.loading]: isLoading
				})
			}}
			disabled={disabled || isLoading}
			disableElevation={disableElevation}
			{...restProps}
		>
			{isLoading ? <Loader classes={{ colorPrimary: theme.colorPrimary }} /> : isSuccess ? Choosed : children}
		</Button>
	);
};

export default IconButton;
